import {
  Box,
  Button,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import useFetchDataWithPagination from "../../../utility/useFetchDataWithPagination";
import PersonRemoveIcon from "@mui/icons-material/PersonRemove";
import EditIcon from "@mui/icons-material/Edit";
import useGetConnectedUser from "../../../utility/useGetConnectedUser";
import usePostData from "../../../utility/usePostData";

const AllowedUserInstution = () => {
  const { userConnected } = useGetConnectedUser();
  const { id } = useParams();
  const { data, isLoading, refreshSearch } = useFetchDataWithPagination(
    "get_user_by_instutions/" + id,
  );
  const [users, setUsers] = useState([]);
  const { submitData } = usePostData();

  // Edit Modal State
  const [openEdit, setOpenEdit] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [editFormData, setEditFormData] = useState({
    name: "",
    email: "",
    telephone: "",
    password: "",
  });

  useEffect(() => {
    if (data?.data) {
      setUsers(data?.data);
    }
  }, [data]);

  const deleteUser = async (id) => {
    const x = window.confirm(`Are you sure you want to delete`);
    if (x) {
      await submitData("users/" + id, null, "DELETE");
      refreshSearch();
    }
  };

  const handleOpenEdit = (user) => {
    setEditingUser(user);
    setEditFormData({
      name: user.name || "",
      email: user.email || "",
      telephone: user.telephone || "",
      password: "", // Always empty initially for security
    });
    setOpenEdit(true);
  };

  const handleCloseEdit = () => {
    setOpenEdit(false);
    setEditingUser(null);
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleEditSubmit = async () => {
    if (!editingUser) return;

    const payload = { ...editFormData };
    // If password is empty, don't send it to avoid overwriting with empty string
    if (!payload.password) {
      delete payload.password;
    }

    await submitData("users/" + editingUser.id, payload, "PUT");
    handleCloseEdit();
    refreshSearch();
  };

  return (
    <Box>
      <Grid container>
        {isLoading && <div>Loading...</div>}
        <Grid item md={12}>
          <h6>Liste des utilisateurs de l'instution</h6>
          <TableContainer sx={{ maxHeight: 440 }}>
            <Table stickyHeader aria-label="sticky table" size="small">
              <TableHead size="small">
                <TableRow size="small">
                  <TableCell>#</TableCell>
                  <TableCell>Nom et prénom</TableCell>
                  <TableCell>Téléphone</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>Role</TableCell>
                  {userConnected.isAdmin() && <TableCell>Action</TableCell>}
                </TableRow>
              </TableHead>
              <TableBody size="small">
                {users.map((row, index) => (
                  <TableRow key={row.id} size="small">
                    <TableCell component="th" scope="row">
                      {index + 1}
                    </TableCell>
                    <TableCell>{row.name}</TableCell>
                    <TableCell>{row.telephone}</TableCell>
                    <TableCell>{row.email}</TableCell>
                    <TableCell>{row.role?.name}</TableCell>
                    {userConnected.isAdmin() && (
                      <TableCell>
                        <Box sx={{ display: "flex", gap: 1 }}>
                          <Button
                            variant="outlined"
                            size="small"
                            color="primary"
                            onClick={() => handleOpenEdit(row)}
                            sx={{ minWidth: "auto", p: 0.5 }}
                          >
                            <EditIcon fontSize="small" />
                          </Button>
                          <Button
                            variant="outlined"
                            size="small"
                            color="error"
                            onClick={() => deleteUser(row.id)}
                            sx={{ minWidth: "auto", p: 0.5 }}
                          >
                            <PersonRemoveIcon fontSize="small" />
                          </Button>
                        </Box>
                      </TableCell>
                    )}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>

      {/* Edit User Modal */}
      <Dialog open={openEdit} onClose={handleCloseEdit} fullWidth maxWidth="sm">
        <DialogTitle>Modifier l'utilisateur</DialogTitle>
        <DialogContent>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2, pt: 1 }}>
            <TextField
              label="Nom et Prénom"
              name="name"
              value={editFormData.name}
              onChange={handleEditChange}
              fullWidth
              variant="outlined"
            />
            <TextField
              label="Email"
              name="email"
              type="email"
              value={editFormData.email}
              onChange={handleEditChange}
              fullWidth
              variant="outlined"
            />
            <TextField
              label="Téléphone"
              name="telephone"
              value={editFormData.telephone}
              onChange={handleEditChange}
              fullWidth
              variant="outlined"
            />
            <TextField
              label="Mot de passe (laisser vide pour ne pas modifier)"
              name="password"
              type="password"
              value={editFormData.password}
              onChange={handleEditChange}
              fullWidth
              variant="outlined"
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseEdit}>Annuler</Button>
          <Button
            onClick={handleEditSubmit}
            variant="contained"
            color="primary"
          >
            Enregistrer
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AllowedUserInstution;
